export default __webpack_public_path__ + "static/media/newspaper.90131ad6.svg";